const STORAGE_KEY = "vertex_lab_user_profile";

export const OPCIONES_SEXO = ["Mujer", "Hombre", "Otro", "No quiero decir"];

export const OPCIONES_EDAD = [
  "0 - 5 años",
  "6 - 10 años",
  "11 - 18 años",
  "19 - 60 años",
  "Más de 60 años"
];

// Valores crudos, para precargar el formulario
export const getUserProfile = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { sexo: "", edad: "" };

    const { sexo = "", edad = "" } = JSON.parse(raw);
    return { sexo, edad };
  } catch {
    return { sexo: "", edad: "" };
  }
};

// Valores con el prefijo que espera GTM/GA4, para anexarlos a cada evento
export const getTrackingProfile = () => {
  const { sexo, edad } = getUserProfile();
  if (!sexo || !edad) return {};

  return { user_sexo: sexo, user_edad: edad };
};

export const saveUserProfile = ({ sexo, edad }) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ sexo, edad }));
  } catch {
    // Si el navegador bloquea el storage, el perfil sólo viaja en el evento
  }
};
